
import { defineComponent, inject, PropType } from 'vue';
import { useDialogPresets } from '@/services/dialogPresets.composable';
import { useAgentActionsMenu } from '@/components/agents-table/AgentActionsMenu.helpers';
import { License_RegisterAgentAction } from '@/graphql/codegen/generated/graphql';
import { IKPlatformAuthentication } from '@/modules/platformAuthentication/platformAuthentication.injectionKeys';
import { OsType } from '@/modules/platformAuthentication/platformAuthentication.const';
import { SelectedAgent } from './AgentActionMenu.types';

export default defineComponent({
  name: 'AgentLimitedBulkActionMenu',
  props: {
    agents: {
      type: Array as PropType<SelectedAgent[]>,
      required: true,
    },
  },
  setup() {
    const platformAuthentication = inject(IKPlatformAuthentication);
    const agentsActions = useAgentActionsMenu(platformAuthentication?.osType.value || OsType.Windows);
    const { dialogPresets } = useDialogPresets();
    return { agentsActions, dialogPresets };
  },
  methods: {
    releaseLicenses() {
      this.dialogPresets.resolveAgentsDialog(() => this.agentsActions.setRemoveAgentLicense(this.agents, License_RegisterAgentAction.Resolve));
    },
  },
});
